import Cookies from "js-cookie";

const persistCookie = (key, value, time = 30) => { // defaults to 30 days
  Cookies.set(key, JSON.stringify(value), { expires: time, path: "/" }); 
};

const getCookie = (key) => {
  const cookieValue = Cookies.get(key);
  return cookieValue ? JSON.parse(cookieValue) : undefined;
};

const removeCookie = (key) => {
  Cookies.remove(key, { path: "/" });
};

export { persistCookie, getCookie, removeCookie };